export default __webpack_public_path__ + "2fecda107cd746c7aab6860e79df5d14.jpeg";